import axios from 'axios';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getAllCookies } from '@/utils/cookies';
import { getCPFFromToken } from './util';

export const setupPositionAPIClient = () => {
  const cookies = getAllCookies();
  const authToken = cookies[authKeys.authToken] || '';
  const cpf = getCPFFromToken(authToken);

  const api = axios.create({
    baseURL: apiConfig.baseURL,
    headers: {
      Authorization: authToken ? `Bearer ${authToken}` : undefined,
      'x-eqi-customer-document': cpf,
      'x-eqi-customer-id': cpf,
    },
  });

  return api;
};
